import React from "react";
import { StyledCellContainer } from "../HyroTable.styles";
import { styledTextFieldClasses } from "@hyro-components/fields/text-field/HyroTextField.styles";
import HyroTruncateTypography from "@hyro-components/hyro-truncate-typography/HyroTruncateTypography";
import { CELL_CONTAINER_CLASS } from "../HyroTable.consts";

const TableCell = ({
  params,
  column,
  colIndex,
  truncateCellText = true
}) => (
  <StyledCellContainer
    data-testid={`row-${params.row.index}-table-cell-${colIndex}`}
    className={CELL_CONTAINER_CLASS}
    isDisabledColumn={column.isReadonlyFromSpec}
    isEditable={column.editable || column.hasCellEditor}>
    {column.renderCell ?
      column.renderCell(params) :
      <HyroTruncateTypography
        variant="body2"
        lines={truncateCellText ? 3 : 0}
        maxWidth={`${params.colDef?.minWidth}px`}
      >
        {params.value}
      </HyroTruncateTypography>
    }
    {params?.value && column.renderCopyIcon ? (
      <span className={styledTextFieldClasses.copyIcon}>
        {column.renderCopyIcon({ ...params, isCellHovered: false })}
      </span>
    ) : null}
  </StyledCellContainer>
);

export default TableCell;
